var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsApp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#whats-app_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.006 12.25h-.012C26.761 12.25 16 23.014 16 36.25c0 5.25 1.692 10.116 4.569 14.067l-2.991 8.916 9.225-2.949a23.792 23.792 0 0013.203 3.966C53.239 60.25 64 49.483 64 36.25s-10.761-24-23.994-24z",
    fill: "#31BB01"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.277 46.204c-.589 1.625-2.928 2.973-4.794 3.366-1.276.266-2.944.477-8.556-1.795-7.18-2.904-11.803-10.028-12.163-10.49-.345-.462-2.901-3.772-2.901-7.195 0-3.424 1.78-5.09 2.498-5.806.59-.588 1.563-.856 2.498-.856.302 0 .574.015.818.027.718.03 1.078.071 1.551 1.178.59 1.386 2.025 4.81 2.196 5.161.174.352.348.83.104 1.291-.23.478-.43.69-.791 1.095-.36.405-.702.716-1.063 1.15-.33.38-.702.785-.287 1.486.416.686 1.85 2.973 3.964 4.81 2.727 2.37 4.938 3.128 5.729 3.45.589.238 1.291.182 1.722-.266.547-.575 1.221-1.53 1.908-2.469.489-.674 1.106-.757 1.753-.519.66.224 4.15 1.909 4.868 2.258.717.352 1.19.519 1.365.814.17.295.17 1.682-.419 3.31z",
    fill: "#FAFAFA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "whats-app_svg__filter0_d",
    x: 0,
    y: 0.25,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
export default SvgWhatsApp;